import { FunctionCall } from "components/hooks/useTaskAgentState";
import {
  DefaultActionContainer,
  DefaultActionDisplay,
} from "./DefaultActionDisplay";
import { ActionType, getActionType, getActionDisplayName } from "./ActionTypes";
import BrowserUseActionDisplay from "./BrowserUseActionDisplay";
import ForumActionDisplay from "./ForumActionDisplay";

interface ActionDisplayProps {
  call: FunctionCall;
  accountType?: "advisor" | "member";
}

export const ActionDisplay = ({
  call,
  accountType = "advisor",
}: ActionDisplayProps) => {
  const actionType = getActionType(call.name);
  const displayName =
    getActionDisplayName(call.name) || call.displayName || call.name;

  switch (actionType) {
    case ActionType.BROWSER_USE:
      return <BrowserUseActionDisplay call={call} displayName={displayName} />;
    case ActionType.FORUM_SEARCH:
      return (
        <ForumActionDisplay
          call={call}
          displayName={displayName}
          accountType={accountType}
        />
      );
    case ActionType.FETCH_FORUM_POST:
      return (
        <DefaultActionContainer
          call={call}
          displayName={displayName}
          actionSummary={""}
        />
      );
    case ActionType.DOCUMENT_SEARCH:
    case ActionType.GET_DOCUMENT:
      // For members, show generic message
      if (accountType === "member") {
        // Backend may send source_count instead of sources array for members
        const count = (call as any).source_count || (call.sources || []).length;
        const sourcesLength = (call.sources || []).length;
        return (
          <DefaultActionContainer
            call={call}
            displayName={displayName}
            actionSummary={
              count > 0 ? `Read ${count} document${count !== 1 ? "s" : ""}` : ""
            }
            hideChevron={sourcesLength === 0}
          />
        );
      }
      return (
        <DefaultActionDisplay
          accountType={accountType}
          call={call}
          displayName={displayName}
        />
      );
    default:
      return (
        <DefaultActionDisplay
          accountType={accountType}
          call={call}
          displayName={displayName}
        />
      );
  }
};
